/* eslint-disable max-len */
import React from 'react';
import Button from '@material-ui/core/Button';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import Header from '../../../../../../components/Stake/header';
import DotIcon from '../../../../../../assets/images/tokens/dot.svg';
import DelegateImage from '../../../../../../assets/images/dot-delegate.svg';
import { DOT } from '../../../../../../constants/blockchain-constants';
import config from '../../../../../../config/env';

import stylesParent from '../../styles/frame/frame.module.scss';
import stylesConnect from '../../styles/connect/connect.module.scss';

const Nominate = (props) => {
  const dark = useSelector((state) => state.basic.dark);

  const addresses = `${config.REACT_APP_POLKADOT_VALIDATOR_ADDRESSES}`;
  const nodeAddresses = addresses.split(',');

  const addressesList = nodeAddresses.map((adddress) => (
    <p style={{ fontSize: '11px' }}>{adddress}</p>
  ));

  return (
    <>
      <Header icon={DotIcon} title={`${DOT}-Nomination`} />
      <div className={stylesConnect.delegateContainer}>
        <img className={stylesConnect.delegateBackground} src={DelegateImage} alt='' />
        <div
          className={cn(
            stylesParent.cardFooterControls,
            stylesParent.withBackground,
            stylesParent.lg,
            {
              [stylesParent.dark]: dark,
            },
          )}
        >
          <div style={{ height: '140px' }}>
            <a
              style={{ color: dark ? 'white' : 'black' }}
              href='https://docs.google.com/document/d/1I7Ap0581vyiqpIlLujWXmrVsZ6CodgiCdHmFpryPgwQ'
              target='_blank'
              rel='noreferrer nofollow noopener'
            >
              <p>Polkadot nominating guide</p>
            </a>
            <p>MANTRA DAO node addresses:</p>
            {addressesList}
          </div>
          <Button
            onClick={() => {}}
            variant='contained'
            color='secondary'
            className={stylesParent.cardFooterControlsButton}
          >
            <a
              className={stylesParent.cardFooterControlsButton}
              target='_blank'
              rel='noreferrer nofollow noopener'
              href='https://polkadot.js.org/apps/?rpc=wss%3A%2F%2Frpc.polkadot.io#/staking'
            >
              Nominate in Polkadot
            </a>
          </Button>

          <Button
            onClick={() => {
              props.setStatus(2);
            }}
            style={{ textTransform: 'none', marginTop: '0', width: '100%', borderRadius: '25px' }}
            variant='contained'
          >
            <span style={{ fontWeight: 800, color: 'gray' }}>Skip to claims</span>
          </Button>
        </div>
      </div>
    </>
  );
};

export default Nominate;
